import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from 'fuse-ui/components/Button';

const styles = theme => ( {
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    paddedButton: {
        paddingTop: theme.spacing.unit,
    }
} );

const ResetFilterButton = ( { classes, onClick, noPadding } ) => {
    return (
        <div className={`${classes.buttonContainer} ${noPadding ? '' : classes.paddedButton}`}>
            <Button variant="text" onClick={ onClick }>
                Clear Filter
            </Button>
        </div>
    );
};

ResetFilterButton.propTypes = {
    classes: PropTypes.object.isRequired,
    noPadding: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

export default withStyles( styles )( ResetFilterButton );
